import { Toolbar } from "@material-ui/core";
import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";
import useLink from "@qpr/client-api-base/hooks/useLink";
import Loader from "@qpr/client-api-base/ui/components/Loader";
import useElement from "backend/hooks/elements/useElement";
import useFlatHierarchy from "backend/hooks/elements/useFlatHierarchy";
import useHierarchy from "backend/hooks/elements/useHierarchy";
import PeriodSelector from "components/PeriodSelector";
import ToolbarWithHeading from "components/toolbars/ToolbarWithHeading";
import {
  InitiativesHeader,
  KpisHeader,
  MeasurementHeader,
} from "design/components/texts/Headers";
import { KPICard } from "design/components/cards/KPICard";
import Todo from "design/components/misc/Todo";
import KPIGridArea from "design/components/grids/MeasureGridArea";
import PageContainer from "design/layouts/PageContainer";
import SplitView from "design/layouts/SplitView";
import Page from "design/pages/Page";
import React from "react";
import ToolbarWithMeasureName from "components/toolbars/ToolbarWithMeasureName";
import { InitiativeCard } from "design/components/cards/InitiativeCard";

const KPisAndInitiaivesView = () => {
  const ctx = useAppContext();
  const link = useLink();
  const { data, isLoading, isPreviousData, isRefetching } = useFlatHierarchy(
    ctx.elementId
  );
  const { data: element, isLoading: isElementLoading } = useElement(
    ctx.elementId
  );

  const kpis = React.useMemo(() => {
    return data?.filter((item) => item.typename === "KPI") || [];
  }, [data]);
  const initiaves = React.useMemo(() => {
    return data?.filter((item) => item.typename === "Initiative") || [];
  }, [data]);

  return (
    <Page
      isLoading={
        isLoading || isPreviousData || isRefetching || isElementLoading
      }
      Toolbar={ToolbarWithMeasureName}
    >
      <PageContainer width="1400px">
        <SplitView gap="20px">
          <div>
            <KPIGridArea>
              <KpisHeader header="KPIs" />
              {kpis
                ? kpis.map((el) => (
                    <KPICard
                      valueKey="PERF_YTD"
                      prettyKey="PERF_YTD_prettyvalue"
                      colorKey="rangecolor_PERF_YTD_OPEN"
                      series={[
                        {
                          title: "Actual (YTD)",
                          series: "ACT_YTD_prettyvalue",
                        },
                        {
                          title: "Target (YTD)",
                          series: "TAR_YTD_prettyvalue",
                        },
                      ]}
                      period={ctx.period || ""}
                      key={`${el.id}-${ctx.period}`}
                      element={el}
                      onSelect={() => {
                        link({ page: "kpidetails", meaId: el.id });
                      }}
                    />
                  ))
                : null}
            </KPIGridArea>
          </div>
          <div>
            <KPIGridArea>
              <InitiativesHeader header="Initiatives" />
              {initiaves
                ? initiaves.map((el) => (
                    <InitiativeCard
                      left_number_key="PLANNED_COMPLETION_prettyvalue"
                      left_number_title="Planned Progress"
                      right_number_key="VARIANCE_prettyvalue"
                      right_number_title="Variance"
                      cardTitle="Actual Progress"
                      period={ctx.period || ""}
                      key={`${el.id}-${ctx.period}`}
                      element={el}
                      onSelect={() => {
                        link({ page: "initiativedetails", meaId: el.id });
                      }}
                    />
                  ))
                : null}
            </KPIGridArea>
          </div>
        </SplitView>
      </PageContainer>
    </Page>
  );
};

export default KPisAndInitiaivesView;
